import { render, staticRenderFns } from "./FloatingNav.vue?vue&type=template&id=74bd618b&scoped=true"
import script from "./FloatingNav.vue?vue&type=script&lang=js"
export * from "./FloatingNav.vue?vue&type=script&lang=js"
import style0 from "./FloatingNav.vue?vue&type=style&index=0&id=74bd618b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bd618b",
  null
  
)

export default component.exports